import {createEntityAdapter, createSelector, createSlice} from '@reduxjs/toolkit';
import {DeviceEvent, DeviceEventSerializer} from 'contracts/holotrak/deviceEvent';
import {Trip, TripSerializer} from 'contracts/holotrak/trip';
import {TRIPS_REDUCER_KEY} from 'contracts/reduxResourceTags';
import {tripsApi} from 'redux/services/losant/trips';
import {RootState} from 'redux/store';


export const tripsAdapter = createEntityAdapter<Trip>({
    selectId: (trip) => trip.id,
});
export const tripsEventsAdapter = createEntityAdapter<DeviceEvent>({
    selectId: (event) => event.id,
});

const initialState = {
    trips: tripsAdapter.getInitialState(),
    tripsEvent: tripsEventsAdapter.getInitialState()
}

export const tripSlice = createSlice({
    name: TRIPS_REDUCER_KEY,
    initialState,
    reducers: {
        clearTrips: (state) => {
            tripsAdapter.removeAll(state.trips)
        },
        clearTripsEvents: (state) => {
            tripsEventsAdapter.removeAll(state.tripsEvent)
        }
    },
    extraReducers: (builder) => {
        builder.addMatcher(
            tripsApi.endpoints.getDeviceTrips.matchFulfilled,
            (state, {payload}) => {
                tripsAdapter.addMany(state.trips, payload)
            }
        );

        builder.addMatcher(
            tripsApi.endpoints.getDeviceEvents.matchFulfilled,
            (state, {payload}) => {
                if (payload.items?.length > 0) {
                    tripsEventsAdapter.addMany(state.tripsEvent, payload.items);
                }
            }
        );

    },
});

export default tripSlice.reducer;
export const {clearTrips, clearTripsEvents} = tripSlice.actions;

export const {
    selectAll: getAllTripsFromAdapter,
} = tripsAdapter.getSelectors((state: RootState) => state.tripsCore.trips)

export const selectAllTrips = createSelector(
    getAllTripsFromAdapter,
    (trips) => {
        return trips.map(trip => TripSerializer.parse(trip)) || [];
    }
);

export const {
    selectAll: getAllEventTripsFromAdapter,
} = tripsEventsAdapter.getSelectors((state: RootState) => state.tripsCore.tripsEvent)

export const selectAllEventsTrips = createSelector(
    getAllEventTripsFromAdapter,
    (tripsEvent) => {
        return tripsEvent
            .map((event) => DeviceEventSerializer.parse(event))
            .sort((a, b) => {
                return b.creationDate.diff(a.creationDate, 'seconds')
            })
            .map((event, i) => {
                event.sNo = `${i+1}`;
                return event;
            })
            ;
    }
);
